module.exports = __webpack_public_path__ + "img/logoatualizado.2046fc77.gif";